import { render, staticRenderFns } from "./RelatorioJobView.vue?vue&type=template&id=196b1206&scoped=true"
import script from "./RelatorioJobView.vue?vue&type=script&lang=js"
export * from "./RelatorioJobView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioJobView.vue?vue&type=style&index=0&id=196b1206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b1206",
  null
  
)

export default component.exports